module.exports = __webpack_public_path__ + "img/icon_jrwm.10fb00c5.png";